import { wealthProApi } from "../../redux/api";

const adviserDashboardSummaryApiEndpoints = wealthProApi.injectEndpoints ({
    endpoints: (builder) => ({
        getAdviserProjectsSummary: builder.query({
            query: ({ userId }) => `api/clientprojectsummary/users/${userId}/projects/summary`,
        }),
    })
})

export const {
   useGetAdviserProjectsSummaryQuery
} = adviserDashboardSummaryApiEndpoints;
